interface LogoProps {
  className?: string;
}

export function ZelleLogo({ className }: LogoProps) {
  return (
    <svg viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
      <rect width="40" height="40" rx="8" fill="#6D1ED4" />
      <path d="M27 12H13l9 8H13v4h14l-9-8h9v-4z" fill="white" />
    </svg>
  );
}

export function StripeLogo({ className }: LogoProps) {
  return (
    <svg viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
      <rect width="40" height="40" rx="8" fill="#635BFF" />
      <path
        d="M20 15.2c-2.3 0-3.8 1.1-3.8 2.8 0 1.9 1.8 2.5 3.6 3 1.6.5 2 .8 2 1.4 0 .7-.7 1.1-1.9 1.1-1.4 0-2.6-.5-3.5-1.1l-.6 2c.9.6 2.3 1 3.9 1 2.5 0 4.1-1.2 4.1-3 0-1.9-1.7-2.5-3.5-3-1.6-.5-2.1-.8-2.1-1.4 0-.6.6-1 1.8-1 1.2 0 2.2.4 3 .9l.6-2c-.9-.5-2-.7-3.6-.7z"
        fill="white"
      />
    </svg>
  );
}

export function VenmoLogo({ className }: LogoProps) {
  return (
    <svg viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
      <rect width="40" height="40" rx="8" fill="#3D95CE" />
      <path
        d="M28 12.5c.4.7.6 1.5.6 2.5 0 3.1-2.6 7.2-4.8 10H14.5L11 13l7.4-.7 1.7 7c1.6-2.6 3.6-6.7 3.6-9.5 0-.9-.2-1.6-.5-2.2L28 12.5z"
        fill="white"
      />
    </svg>
  );
}

export function CashLogo({ className }: LogoProps) {
  return (
    <svg viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
      <rect width="40" height="40" rx="8" fill="#16A34A" />
      <rect x="9" y="14" width="22" height="12" rx="1.5" fill="white" />
      <circle cx="20" cy="20" r="3" fill="#16A34A" />
    </svg>
  );
}

export function CheckLogo({ className }: LogoProps) {
  return (
    <svg viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
      <rect width="40" height="40" rx="8" fill="#334155" />
      <rect x="9" y="13" width="22" height="14" rx="1.5" fill="white" />
      <path d="M12 22l3 3 6-6" stroke="#334155" strokeWidth="1.6" fill="none" strokeLinecap="round" strokeLinejoin="round" />
      <line x1="24" y1="18" x2="28" y2="18" stroke="#334155" strokeWidth="1.4" strokeLinecap="round" />
    </svg>
  );
}
